export const exportToCSV = ({ data, headers, filename = "reporte" }) => {
  if (!data || data.length === 0) {
    console.warn("No hay datos para exportar.");
    return;
  }

  // Convertir headers: si es un array de strings, se usan directo
  const headerTitles = headers.map(h => `"${h.title}"`);
  const keys = headers.map(h => h.key);

  // Construir filas
  const rows = data.map(row =>
    keys.map(key => {
      const value = key.includes('.') ? resolveNestedValue(row, key) : row[key];
      return `"${value !== undefined && value !== null ? value : ''}"`;
    }).join(',')
  );

  // Crear contenido CSV
  const csvContent = [headerTitles.join(','), ...rows].join('\n');

  // 👉 Agregar el BOM para compatibilidad con Excel y acentos
  const BOM = '\uFEFF';
  // Crear blob y descargar
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Función para acceder a valores anidados con "key1.key2"
function resolveNestedValue(obj, path) {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}
